import { IconName } from '@fortawesome/fontawesome-svg-core';

export const NAV_ITEMS: {
  text: string;
  items: { text: string; icon: IconName; route?: string }[];
}[] = [
  {
    text: 'HOSTING',
    items: [
      {
        text: 'Websites and Groups',
        icon: 'globe',
        route: '/dashboard',
      },
      {
        text: 'Migrations',
        icon: 'arrow-right-arrow-left',
      },
      {
        text: 'SSL Certificates',
        icon: 'bookmark',
        route: '/ssl',
      },
      {
        text: 'DNS Zones',
        icon: 'network-wired',
        route: '/dns-zones',
      },
      {
        text: 'Email',
        icon: 'envelope',
        route: '/email',
      },
      {
        text: 'Usage',
        icon: 'chart-simple',
        route: '/usage',
      },
      {
        text: 'Databases',
        icon: 'database',
        route: '/databases',
      },
      {
        text: 'FTP Users',
        icon: 'folder-open',
      },
      {
        text: 'Site history',
        icon: 'clock-rotate-left',
      },
    ],
  },
  {
    text: 'SERVERS',
    items: [
      {
        text: 'Servers',
        icon: 'server',
      },
      {
        text: 'Plans',
        icon: 'calendar',
      },
      {
        text: 'SSH Users',
        icon: 'users',
      },
      {
        text: 'CDN Vhosts',
        icon: 'database',
      },
      {
        text: 'Origin Vhosts',
        icon: 'bolt',
      },
      {
        text: 'Backup & Restore',
        icon: 'arrow-rotate-left',
      },
    ],
  },
  {
    text: 'SYSTEM',
    items: [
      {
        text: 'User Settings',
        icon: 'user-gear',
      },
      {
        text: 'Logs',
        icon: 'clipboard-list',
      },
      {
        text: 'Reports',
        icon: 'magnifying-glass-chart',
      },
      {
        text: 'Documentation',
        icon: 'file-lines',
      },
    ],
  },
];
